import type {ID} from '../../../../utils/utility-types';
import type {CourseModel} from '../../../domain/Course/Course.model';
import type {MembershipModel} from '../../../domain/Membership/Membership.model';

export abstract class ToggleEmployeeSubscriptionCmd {
  abstract exec(
    props: ToggleEmployeeSubscriptionCmd.Props,
  ): Promise<ToggleEmployeeSubscriptionCmd.Response>;
}

export namespace ToggleEmployeeSubscriptionCmd {
  export type Props = {
    cancel?: {
      id: ID;
    };
    restart?: {
      cardId: ID;
      id: ID;
    };
  };
  export type Response = {
    course: Pick<
      CourseModel.Props,
      'id' | 'isAutoRestarting' | 'restart' | 'updatedDate'
    >;
    membership: Pick<MembershipModel.Props, 'cardId' | 'id'>;
  };
}
